import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("a", {
    class: _normalizeClass({ 'disabled': $props.revalStatus === 'RequiresRevalidation' }),
    href: $options.adjustedHref
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 10, _hoisted_1))
}